import { render, staticRenderFns } from "./AdminSuperResellers.vue?vue&type=template&id=168044ba&lang=pug&"
import script from "./AdminSuperResellers.vue?vue&type=script&lang=js&"
export * from "./AdminSuperResellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports